import { jsxs as e, jsx as l } from "react/jsx-runtime";
import { getIconStyles as o } from "../styles.js";
const d = (i) => /* @__PURE__ */ e(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: o(i),
    children: [
      /* @__PURE__ */ e("g", { clipPath: "url(#clip0_3922_22216)", children: [
        /* @__PURE__ */ l(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M18 5.99695C18.4142 5.99695 18.75 6.33273 18.75 6.74695V8.99995C18.75 10.3923 18.1969 11.7277 17.2123 12.7123C16.2277 13.6968 14.8924 14.2499 13.5 14.2499H6C5.58579 14.2499 5.25 13.9142 5.25 13.4999C5.25 13.0857 5.58579 12.7499 6 12.7499H13.5C14.4946 12.7499 15.4484 12.3549 16.1517 11.6516C16.8549 10.9483 17.25 9.99451 17.25 8.99995V6.74695C17.25 6.33273 17.5858 5.99695 18 5.99695Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M10.2803 9.21662C10.5732 9.50951 10.5732 9.98438 10.2803 10.2773L7.06066 13.4969L10.2803 16.7166C10.5732 17.0095 10.5732 17.4844 10.2803 17.7773C9.98744 18.0702 9.51256 18.0702 9.21967 17.7773L5.46967 14.0273C5.17678 13.7344 5.17678 13.2595 5.46967 12.9666L9.21967 9.21662C9.51256 8.92373 9.98744 8.92373 10.2803 9.21662Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M4.5 2.24695C3.25736 2.24695 2.25 3.25431 2.25 4.49695V19.4969C2.25 20.7396 3.25736 21.7469 4.5 21.7469H19.5C20.7426 21.7469 21.75 20.7396 21.75 19.4969V4.49695C21.75 3.25431 20.7426 2.24695 19.5 2.24695H4.5ZM0.75 4.49695C0.75 2.42588 2.42893 0.746948 4.5 0.746948H19.5C21.5711 0.746948 23.25 2.42588 23.25 4.49695V19.4969C23.25 21.568 21.5711 23.2469 19.5 23.2469H4.5C2.42893 23.2469 0.75 21.568 0.75 19.4969V4.49695Z",
            fill: "currentColor"
          }
        )
      ] }),
      /* @__PURE__ */ l("defs", { children: /* @__PURE__ */ l("clipPath", { id: "clip0_3922_22216", children: /* @__PURE__ */ l("rect", { width: "24", height: "24", fill: "white" }) }) })
    ]
  }
);
export {
  d as ReplyArrowIcon
};
//# sourceMappingURL=ReplyArrowIcon.js.map
